import React from 'react';
import { Outlet } from 'react-router-dom';

const InvitationsHome = () => {
  return (
    <section className="app-route">
      <Outlet />
    </section>
  );
};

export default InvitationsHome;